export default __webpack_public_path__ + "static/media/sounds/trcBookCompleteReminder.mp3";